export default __webpack_public_path__ + "static/media/icon-check-success.012ab028.svg";